//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/TaggedObject.js";
let d=[[],[[["objectType","objectSubtype","numObjects","costObjects"],"AskCostObjects",{},2,0],[["numObjects","pFacetIds"],"AskFeatureRelatedFacetsWithChildren",{},0,0],[["numberOfParameters","costObjectStringValueList"],"AskCostObjectParameterValues",{},0,0],[["numBodies","convergentBodies"],"AskConvergentBodies",{},0,0],[["isExpanded"],"SetIsChildrenExpanded",{},1,0],[["number","childrenCostFeatures"],"GetChildren",{},0,0],[[],"GetParent",{R_:{parentCostFeature:"Tooling.CostDataObject"}},0,0],[["type"],"SetQuotationType",{},1,0]],[]];
SPLM.Tooling.CostDataObject = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.CostDataObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.CostDataObject.QuotationType = Object.freeze({
    "Formula" : "Formula", "Database" : "Database"});

export default SPLM;